import React from 'react';
import { MuiBox, MuiGrid, MuiTypography, MuiDivider } from 'theme/material-ui';
import { BookingMoreInfoButton } from '../../components/sharedComponents';
import * as bookingTypes from 'store/booking/types';
import SelectSpecialty from '../../components/selectSpecialty';
import ServicesSection from '../servicesSection';

interface Props {
  handleMoreInfoOpen: Function;
  selectedSpecialty: bookingTypes.Specialty | null;
  handleSpecialtySelect: Function;
  specialties: bookingTypes.Specialty[];
}

const SpecialtiesSection = ({
  handleMoreInfoOpen,
  selectedSpecialty,
  handleSpecialtySelect,
  specialties
}: Props) => (
  <>
    <MuiGrid item xs>
      <MuiTypography gutterBottom variant="h5">
        New Provider
      </MuiTypography>
    </MuiGrid>
    <MuiGrid item>
      <BookingMoreInfoButton
        testID="booking-specialty-or-my-doctor-select-more-info-button"
        handleOpen={() => handleMoreInfoOpen()}
        size="medium"
      />
    </MuiGrid>
    <MuiGrid xs={12}>
      <MuiDivider />
    </MuiGrid>
    {/* Select */}
    <MuiGrid xs={12}>
      <MuiBox paddingTop={2} marginTop={3}>
        <SelectSpecialty
          specialties={specialties}
          selectedSpecialty={selectedSpecialty}
          handleSpecialtySelect={handleSpecialtySelect}
        />
      </MuiBox>
    </MuiGrid>
    <ServicesSection />
  </>
);

export default SpecialtiesSection;
